import { showToast } from "../../helpers/Utils";
import { dmApi } from "../../app/dmApi";
import { handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";
import { getAuthorizationHeader } from "../../helpers/RtkQueryUtils";
const authApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        loginUser: build.mutation({
            query: (request) => ({
                url: "/admin/login",
                method: "POST",
                body: request,
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                queryFulfilled.then(res => {
                    localStorage.setItem("authToken", res.data.token)
                }).catch(error => {
                    showToast(error?.error?.data?.message, "error");
                })
            }
        }),
        forgotPassword: build.mutation({
            query: (request) => {
                return {
                    url: `/admin/forget-password`,
                    method: 'POST',
                    body: request,
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "", "A password reset email has been sent to the specified email address, if there is a user associated with it")
            },
        }),
        resetPassword: build.mutation({
            query: (request) => {
                const { token, newPassword } = request;
                return {
                    url: `/admin/reset-password?token=${encodeURIComponent(token)}`,
                    method: 'POST',
                    body: { newPassword },
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(
                    queryFulfilled,
                    '',
                    'Password has been reset successfully'
                );
            },
        }),
    })
})
export const {
    useLoginUserMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation
} = authApi;